import { render, staticRenderFns } from "./button-add-to-cart.vue?vue&type=template&id=82296124"
import script from "./button-add-to-cart.vue?vue&type=script&lang=js"
export * from "./button-add-to-cart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseButton: require('/home/ploi/www.orderchamp.dev-deploy/www.orderchamp.dev/28072026_171207/resources/assets/marketplace/components/BaseButton.vue').default})
